import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { emailApi } from '../../../api/emailApi';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IEmailAddOrEdit } from '../../../models/response/email/IEmailAddOrEdit';
import { IEmailUser } from '../../../models/response/email/IEmailUser';
import { eEmailFormActionTypeIds, IEmailFormActionTypes } from '../../action-types/email/IEmailFormActionTypes';
import { actions } from './../../actions/actionsWrapper';
export function* emailFormSaga(): any {
    yield takeEvery(eEmailFormActionTypeIds.LOAD_EMAIL_START, loadEmailFormWorker)
    yield takeEvery(eEmailFormActionTypeIds.LOAD_EMAIL_USER_START, loadEmailUsersWorker)
    yield takeEvery(eEmailFormActionTypeIds.SAVE_EMAIL_START, saveWorker)
    yield takeEvery(eEmailFormActionTypeIds.SAVE_EMAIL_USER_START, saveUserWorker)
    yield takeLatest(eEmailFormActionTypeIds.SEND_START, sendWorker)
}

function* loadEmailFormWorker(action: IEmailFormActionTypes): any {
    const res: IBaseResponeModel = yield call(emailApi.getEditModel, action.payload as number)
    if (res.is_success) {
        yield put(actions.emailWrapper.form.LOAD_EMAIL_SUCCESS(res.data))
    } else {
        yield put(actions.emailWrapper.form.LOAD_EMAIL_ERROR(res.message ?? "Error"))
    }
}

function* loadEmailUsersWorker(action: IEmailFormActionTypes): any {
    const res: IBaseResponeModel = yield call(emailApi.getUsers, action.payload as number)
    if (res.is_success) {
        yield put(actions.emailWrapper.form.LOAD_EMAIL_USER_SUCCESS(res.data))
    } else {
        yield put(actions.emailWrapper.form.LOAD_EMAIL_USER_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IEmailFormActionTypes): any {
    const res: IBaseResponeModel = yield call(emailApi.save, action.payload as IEmailAddOrEdit)
    if (res.is_success) {
        yield put(actions.emailWrapper.form.SAVE_EMAIL_SUCCESS(res.data))
    } else {
        yield put(actions.emailWrapper.form.SAVE_EMAIL_USER_ERROR(res.message ?? "Error"))
    }
}


function* saveUserWorker(action: IEmailFormActionTypes): any {
    const res: IBaseResponeModel = yield call(emailApi.saveUsers, action.payload as IEmailUser[])
    if (res.is_success) {
        yield put(actions.emailWrapper.form.SAVE_EMAIL_USER_SUCCESS(res.data))
    } else {
        yield put(actions.emailWrapper.form.SAVE_EMAIL_USER_ERROR(res.message ?? "Error"))
    }
}

function* sendWorker(action: IEmailFormActionTypes): any {
    const res: IBaseResponeModel = yield call(emailApi.send, action.payload as number)
    if (res.is_success) {
        yield put(actions.emailWrapper.form.SEND_SUCCESS(res.data))
    } else {
        yield put(actions.emailWrapper.form.SEND_ERROR(res.message ?? "Error"))
    }
}
